import { ChevronRight } from "@mui/icons-material";

import { BreadCrumbsList, BreadcrumbLink, StyledNav } from "./styles";

type BreadCrumbsType = {
  paths: {
    label: string;
    value: string;
  }[];
};

const BreadCrumbs = ({ paths }: BreadCrumbsType) => {
  return (
    <StyledNav>
      <BreadCrumbsList>
        {paths.map((path, index) => {
          if (index === paths.length - 1) {
            return <li key={index}>{path.label}</li>;
          }

          return (
            <li key={index}>
              <BreadcrumbLink to={`/admin/${path.value.toLowerCase()}`}>
                {path.label}
              </BreadcrumbLink>
              <ChevronRight />
            </li>
          );
        })}
      </BreadCrumbsList>
    </StyledNav>
  );
};

export default BreadCrumbs;
